import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    width: 'auto',
    height: 45,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      src="/ciclusrio-logo.svg"
      alt="CiclusRio Logo"
      className={classes.logo}
    />
  );
};

export default LogoFull;
